export default {
      id: "icon--chevron-grey-usage",
      viewBox: "0 0 13 7",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-grey-usage",
      toString: function () {
        return this.url;
      }
    }